import initialState from './initialState';
import { SET_MTD } from '../actions/actionTypes';


export default function mtd(state = initialState.mtd, action) {
  switch (action.type) {
    case SET_MTD:
      return action.setToVal;
    default:
      return state;
  }
}
